import { Popover } from 'antd';

const brokerList = [
  {
    name: 'Interactive Brokers',
    url: 'https://www.benzinga.com/go/ibkr-50?pl=product-table',
  },
  {
    name: 'Webull',
    url: 'https://www.benzinga.com/go/webull-how-to-buy?pl=product-table',
  },
  {
    name: 'TradeStation',
    url: 'https://www.benzinga.com/go/tradestation?pl=product-table',
  },
  {
    name: 'TD Ameritrade',
    url: 'https://www.benzinga.com/go/td-ameritrade-platform?pl=product-table',
  },
  {
    name: 'Cobra Trading',
    url: 'https://www.benzinga.com/go/cobra-trading?pl=product-table',
  },
  {
    name: 'Moomoo',
    url: 'https://www.benzinga.com/go/moomoo?pl=product-table',
  },
  {
    name: 'NinjaTrader',
    url: 'https://www.benzinga.com/go/ninjatrader-review?pl=product-table',
  },
  {
    name: 'Robinhood',
    url: 'https://www.benzinga.com/go/robinhood?pl=product-table',
  },
  {
    name: 'IG',
    url: 'https://www.benzinga.com/go/ig-market?pl=product-table',
  },
  {
    name: 'Tradovate',
    url: 'https://www.benzinga.com/go/tradovate?pl=product-table',
  },
];

export const TradeNowButton = ({ compact = false }: { compact?: boolean }) => {
  const badgeContent = (
    <div className="flex max-w-[300px] flex-col rounded-md bg-bzblue-800 p-4 text-white">
      <div className="mb-4 text-xl font-bold">Select a Broker:</div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-3">
        {brokerList.map(broker => (
          <a
            key={broker.name}
            href={broker.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full rounded-md bg-white p-2 text-center text-xs text-bzblue-800 hover:bg-bzblue-700 hover:text-white"
          >
            {broker.name}
          </a>
        ))}
      </div>
    </div>
  );

  return (
    <Popover rootClassName="trade-ideas-popover" content={badgeContent} title="" arrow={false}>
      <button
        type="button"
        className={
          compact
            ? 'inline-block shrink-0 rounded-md border border-white/25 bg-white/10 px-2.5 py-1 text-xs font-semibold text-white hover:border-white/40 hover:bg-white/15'
            : 'inline-block h-fit rounded-lg bg-white px-4 py-2 font-bold text-bzblue-1000 hover:bg-bzblue-700 hover:text-white hover:shadow-xl'
        }
      >
        Trade
      </button>
    </Popover>
  );
};
